module.exports = __webpack_public_path__ + "assets/monitoring.05dd4376.svg";